import React, { useEffect, useState } from "react";
import StatCard from "./StateCard";
import { fetchAllData } from "../../helper/ProductAttributeHandling";
import OrderList from "./OrderList";
import { Link } from "react-router-dom";
import ActionPermission from "../../Auth/ActionPermission";
const Dashboard = () => {
    const [order,setorder]=useState({})
     const [loading, setLoading] = useState(true);
     const [data,setData]=useState([])
    const fetchdata = async () => {
        await fetchAllData(`/dashboard`, setorder);
        fetchAllData("/dashboard-order",setData,null,setLoading)
    }

    useEffect(() => {
        
        fetchdata()
    }, [])

    return (
        <>
            <div className="content-wrapper">
                <div className="row mt-5" >
                    <div className="col-md-3 col-12 mt-2" >
                    <Link to={"/orders"} className="text-decoration-none text-dark">
                        <StatCard label="Total Orders" value={order?.totalOrder} color="#6366f1" />
                    </Link>
                    </div>
                    <div className="col-md-3 mt-2">
                     <Link to={"/orders"} className="text-decoration-none text-dark">
                        <StatCard label="Booked Orders" value={order?.bookedOrder} color="#10b981" />
                     </Link>
                    </div>
                    <div className="col-md-3 col-12 mt-2">
                     <Link to={"/orders"} className="text-decoration-none text-dark">
                        <StatCard label="Cancel Orders" value={order?.cancelOrder} color="#f97316" />
                     </Link>
                    </div>
                    <div className="col-md-3 col-12 mt-2">
                      <Link to={"/orders"} className="text-decoration-none text-dark">
                        <StatCard label="Pending Orders" value={order?.pendingOrder || 0} color="#7c3aed" />
                      </Link>
                    </div>
                    <div className="col-md-12 mt-4">
                    <ActionPermission pageKey="Dashboard" action={"Order List"}>
                        <OrderList data={data} loading={loading}/>
                    </ActionPermission>
                    </div>
                </div>

            </div>
        </>
    );
};

export default Dashboard;
